import React from 'react';
import { Tab, Table } from 'semantic-ui-react';
import SearchViewTableBody from './SearchViewTableBody';
import { ReportData } from './types';

interface PropTypes {
  reportData: ReportData[];
  searchesToAssign: number[];
  setSearchesToAssign: React.Dispatch<React.SetStateAction<number[]>>;
  setReportData: React.Dispatch<React.SetStateAction<ReportData[]>>;
  onSubmit: (queryString?: string) => Promise<void>
}

const TableWrapper = (props: PropTypes) => {
  return (
    <Table fixed sortable compact singleLine size="small" className="tableTwelve">
      <SearchViewTableBody
        reportData={props.reportData}
        searchesToAssign={props.searchesToAssign}
        setSearchesToAssign={props.setSearchesToAssign}
        setReportData={props.setReportData}
        onSubmit={props.onSubmit}
      />
    </Table>
  );
};

export default TableWrapper;
